// @flow
export const CLASS_TYPES_FILTER_CLEAR: 'reports/CLASS_TYPES_FILTER_CLEAR' = 'reports/CLASS_TYPES_FILTER_CLEAR';
export const CLASS_TYPES_FILTER_DELETE: 'reports/CLASS_TYPES_FILTER_DELETE' = 'reports/CLASS_TYPES_FILTER_DELETE';
export const CLASS_TYPES_FILTER_SET: 'reports/CLASS_TYPES_FILTER_SET' = 'reports/CLASS_TYPES_FILTER_SET';
export const CLASS_TYPES_FILTER_UPDATE: 'reports/CLASS_TYPES_FILTER_UPDATE' = 'reports/CLASS_TYPES_FILTER_UPDATE';
